"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CommandKioskRouter;
var _react = _interopRequireDefault(require("react"));
var _CommandKioskCore = _interopRequireDefault(require("./CommandKioskCore"));
var _CommandKioskNewCactusCore = _interopRequireDefault(require("./CommandKioskNewCactusCore"));
var _styles = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Route vers le catalogue CMS (Stripe) ou le menu API New Cactus selon payment_provider.
 */function CommandKioskRouter(props) {
  const merged = (0, _styles.mergeCommandStyles)(props.templateVariant, props.styles_properties);
  if (merged.payment_provider === 'newcactus') {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandKioskNewCactusCore.default, {
      ...props
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommandKioskCore.default, {
    ...props
  });
}